import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 664AA4B5-DD9C-40AD-A69E-3CD314025AD3
 * name arrow-up-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowUpBoldOutlineIcon = createSvgIcon(<><path d="M16,13V21H8V13H2L12,3L22,13H16M7,11H10V19H14V11H17L12,6L7,11Z" /></>, 'ArrowUpBoldOutlineIcon');
export default ArrowUpBoldOutlineIcon